import type {
  StudentConversationOptionsResource,
  StudentConversationRowResource,
} from "api/generated";
import type {
  StudentConversationOptions,
  StudentConversationRow,
} from "conversations/types";
import { parseSchoolDateTime } from "shared/utils";

/**
 * Maps one row of the leerlingoverzicht.
 *
 * `date` carries a Dutch wall-clock moment, so it is read through the school clock rather
 * than the browser's timezone — same as `conversationRowFromDto`.
 */
export const studentConversationRowFromDto = (
  dto: StudentConversationRowResource,
): StudentConversationRow => ({
  id: dto.id,
  name: dto.name,
  date: parseSchoolDateTime(dto.date),
  endDate: parseSchoolDateTime(dto.end_date),
  conversationType: {
    id: dto.conversation_type.id,
    name: dto.conversation_type.name,
  },
  subjectShortage: dto.subject_shortage ?? null,
  partner:
    dto.partner === null
      ? null
      : {
          name: dto.partner.name,
          avatar: dto.partner.avatar,
        },
  teacherShortage: dto.teacher_shortage ?? null,
  isNote: dto.is_note,
  isPrepared: dto.is_prepared,
  status: dto.status,
});

export const studentConversationOptionsFromDto = (
  dto: StudentConversationOptionsResource,
): StudentConversationOptions => ({
  conversationTypes: dto.conversation_types.map((type) => ({
    id: type.id,
    name: type.name,
  })),
  partners: dto.partners.map((partner) => ({
    id: partner.id,
    name: partner.name,
  })),
});
